/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCurrencyDto } from '../../models/backend-currency-dto';

export interface ProjectsCurrenciesList$Params {
  name?: string;
  name_en?: string;

  /**
   * A search term.
   */
  search?: string;
  short_name?: string;
}

export function projectsCurrenciesList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsCurrenciesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendCurrencyDto>>> {
  const rb = new RequestBuilder(rootUrl, projectsCurrenciesList.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('name_en', params.name_en, {});
    rb.query('search', params.search, {});
    rb.query('short_name', params.short_name, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendCurrencyDto>>;
    }),
  );
}

projectsCurrenciesList.PATH = '/api/projects/currencies/';
